import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { SignOut, X } from "phosphor-react";
import { fpost } from "../../API/callsAPI";
import { useState } from "react";

const LeaveTeamModal = ({
  handleClose,
  teamDetails,
  handleRefresh,
  userType,
  selectedProject,
  setSnackValue,
}) => {
  const [isLeaving, setIsLeaving] = useState(false);
  const handleLeaveTeam = async () => {
    try {
      setIsLeaving(true);
      const res = await fpost({
        url:
          userType === "team"
            ? `project-space/${teamDetails?.id}/leave-team/`
            : `project/${selectedProject?.id}/leave-project/`,
      });
      setSnackValue({
        isOpen: true,
        message: `SuccessFully Leaved`,
        isError: false,
      });
      handleRefresh();
      setIsLeaving(false);
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
      setIsLeaving(false);
    }
  };
  return (
    <Box
      sx={{
        backgroundColor: "#1B1D28",
        borderRadius: "20px",
        width: "500px",
        padding: "24px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          // alignItems: "center",
          gap: "24px",
          // textAlign: "center",
        }}
      >
        {/* Header with icon and title */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          {/* <UserCircleMinus size={24} color="#D61F1F" /> */}
          <SignOut size={24} color="#D61F1F" />
          <Typography fontSize={24} fontWeight={500} sx={{ color: "white" }}>
            Leave {userType === "team" ? "Team" : "Project"}
          </Typography>
        </Box>

        {/* Confirmation text */}
        <Typography
          sx={{
            fontSize: "14px",
            color: "#F9F9F9",
          }}
        >
          Are you sure you want to remove this user from{" "}
          <strong>
            {userType === "team" ? teamDetails?.name : selectedProject?.name}
          </strong>
        </Typography>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "16px",
          }}
        >
          <Button
            onClick={handleClose}
            startIcon={<X size={18} />}
            sx={{
              backgroundColor: "transparent",
              color: "#fff",
              border: "2px solid #6C65D9",
              borderRadius: "12px",
              padding: "12px 24px",
              fontSize: "14px",
              textTransform: "none",
              minWidth: "150px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              "&:hover": {
                backgroundColor: "rgba(108, 101, 217, 0.1)",
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleLeaveTeam}
            startIcon={<SignOut size={18} />}
            sx={{
              backgroundColor: "#D61F1F",
              color: "#fff",
              borderRadius: "10px",
              padding: "12px 24px",
              fontSize: "14px",
              textTransform: "none",
              minWidth: "150px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              "&:hover": {
                backgroundColor: "#B91C1C",
              },
              "&:disabled": {
                backgroundColor: "#363232ff",
              },
            }}
            disabled={isLeaving}
          >
            {isLeaving ? (
              <CircularProgress size={20} />
            ) : (
              `Leave ${userType === "team" ? "Team" : "Project"}`
            )}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default LeaveTeamModal;
